import PrivacyPolicy from "../legal/PrivacyPolicy";

export default function PrivacyPage() {

    return <PrivacyPolicy />
};
